import { WeeklyCalendar } from '@app/components/Calendars/WeeklyCalendar/WeeklyCalendar.main';

export { WeeklyCalendar };
